import { j as t } from "../../../../_virtual/jsx-runtime.js";
import o from "styled-components";
import i from "../../../asset/icon/success.svg.js";
const r = o.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`, s = o(i)`
  width: 48px;
  height: 48px;
  margin-bottom: 24px;
`, c = o.h1`
  color: var(--color-text);
  text-align: center;
  font-family: 'Poppins';
  font-size: 20px;
  font-weight: 500;
  margin-bottom: 12px;
`, l = o.p`
  color: var(--color-text-06);
  text-align: center;
  font-family: 'Poppins';
  font-size: 14px;
  font-weight: 400;
`;
function m({ title: n, description: e }) {
  return /* @__PURE__ */ t.jsxs(r, { children: [
    /* @__PURE__ */ t.jsx(s, {}),
    /* @__PURE__ */ t.jsx(c, { children: n }),
    /* @__PURE__ */ t.jsx(l, { children: e })
  ] });
}
export {
  m as default
};
